import { Injectable } from '@angular/core';
import { NotificationDTO, RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { tap } from 'rxjs/operators';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmContactDialogComponent } from '@shared/confirm-contact-dialog/confirm-contact.component';

@Injectable({
	providedIn: 'root',
})
export class CarrierService {
	constructor(
		private urlService: UrlService,
		private restService: RestService,
		private dialog: MatDialog
	) {}

	get(quoteId: string, carrierData: any) {
		const url = this.urlService.getCarrierForBid(quoteId, carrierData);
		return this.restService.GET(url);
	}

	getContactsInfo(carrier: any, carrierData: any): any {
		let contact = {
			carrierName: '',
			contactEmail: '',
			contactPhone: '',
		};
		if (carrier.contacts != undefined && carrier.contacts != null && carrier.contacts.length > 0) {
			var contacts = carrier.contacts.filter(function (contact) {
				return contact.primaryContact;
			});
			if (contacts.length > 0) {
				if (carrierData.carrierName == undefined || carrierData.carrierName == null) {
					contact.carrierName =
						(contacts[0].firstName || '') + ' ' + (contacts[0].lastName || '') || '';
				}

				if (carrierData.contactEmail == undefined || carrierData.contactEmail == null) {
					contact.contactEmail = contacts[0].emailAddress || '';
				}

				if (carrierData.contactPhone == undefined || carrierData.contactPhone == null) {
					contact.contactPhone = contacts[0].phone || '';
				}
			}
		}
		return contact;
	}

	create(quoteId: string, carrierData: any) {
		const url = this.urlService.createCarrierForBid(quoteId);
		return this.restService.POST(url, carrierData);
	}

	search(url: string) {
		return this.restService.GET(url).pipe(
			tap((response: any) => {
				return response;
			})
		);
	}

	confirmContact(notification: NotificationDTO) {
		this.dialog.open(ConfirmContactDialogComponent, {
			width: '600px',
			disableClose: true,
			data: { ...notification },
		});
	}
}
